import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {
  trackPageInteraction,
  getGender,
  ANALYTICS_INTERACTION_CLICK,
  ANALYTICS_POSITION_HEADER,
  ANALYTICS_CONTEXT
} from "@src/helpers/events";
import styles from "./index.css";

import { truncateTitle } from "@src/helpers/formatting";
import { getBackgroundImageUrl } from "@template/helpers/navigationBackgroundImageResolver";
import LazyImage from "@template/components/LazyImage";

const cx = classnames.bind(styles);

const MenuItem = ({
  className,
  item,
  setNavActiveItem,
  saveNavigationItem,
  tabIndex,
  addLastFocusElement
}) => {
  const clickItem = () => {
    setNavActiveItem(item.id);
    addLastFocusElement(`[data-navid='${item.id}']`);
    trackPageInteraction({
      context: ANALYTICS_CONTEXT.openNav,
      interaction: ANALYTICS_INTERACTION_CLICK,
      elementText: item.label,
      properties: {
        positionOnPage: ANALYTICS_POSITION_HEADER,
        gender: getGender(item.gender)
      }
    });
  };

  return (
    <li className={cx(styles.container, className)}>
      <LazyImage
        key={item.id}
        data-navid={item.id}
        className={styles.menuItem}
        type="button"
        onClick={clickItem}
        ref={saveNavigationItem}
        tabIndex={tabIndex}
        data-testid="menu-item"
        src={getBackgroundImageUrl(item.smallAndMediumImageUrl, 320)}
        tag={"button"}
      >
        <p
          className={cx(styles.label, {
            [styles.label__sale]: item.smallAndMediumStyleType === "sale",
            [styles.label__light]: item.smallAndMediumStyleType === "light"
          })}
        >
          {item.smallAndMediumStyleType !== "noTitle" && (
            <span>{truncateTitle(item)}</span>
          )}
          {item.subtitle && (
            <span className={styles.subtitle}>
              {item.subtitle.substring(0, 24)}
            </span>
          )}
        </p>
      </LazyImage>
    </li>
  );
};

MenuItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.any,
  setNavActiveItem: PropTypes.func.isRequired,
  saveNavigationItem: PropTypes.func.isRequired,
  addLastFocusElement: PropTypes.func.isRequired,
  tabIndex: PropTypes.number
};

MenuItem.defaultProps = {
  tabIndex: 0
};

export default MenuItem;
